import { useNavigate } from "react-router-dom";
import DstButton from "../../components/DstButton/DstButton";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="p-3 p-md-5 text-center">
      <h1 className="mb-3">Page introuvable</h1>

      <p className="mb-4">
        Oups… La page que vous cherchez n’existe pas ou a été déplacée.
      </p>

      <DstButton
        value="Retour à l’accueil"
        clickFunction={() => navigate("/")}
      />
    </div>
  );
};

export default NotFound;
